import { Navigate, Outlet, useLocation } from "react-router-dom";
import { localStorageInstance } from "../../utils/localStorage";
import Loader from "../../components/Loader";
import { useAssets } from "../../utils/reactQuery/domainAssets";
import { currentUserId, currentUserToken } from "../../utils/constants";

const Protected = () => {
  const location = useLocation();
  const token = 
    currentUserToken();
  const userId = currentUserId();
  const auth = token && userId;

  if (location.pathname === "/resetpassword/") {
    localStorageInstance.clear();
    return <Outlet />;
  }

  return auth ? <Navigate to="/my-task?tab=mine" /> : <Outlet />;
};

export default Protected;
